import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { Pages } from "components/pages";


const StaffManagementRoute = () => {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }` } exact>
                <Pages.StaffManagement />
            </Route>
            <Route path={ `${ path }/page/:pageNum` } exact>
                <Pages.StaffManagement />
            </Route>
            <Route path={ `${ path }/:eeID` }>
                { ({ match }) => <Pages.StaffManagementEvent match={ match } /> }
            </Route>
            <Route path="*">
                <Pages.Page404 />
            </Route>
        </Switch>
    );
};

export default StaffManagementRoute;
